import React from 'react';
import imgleft from '../../../images/createSiteSearch/img_design_form.png';
import imgright from '../../../images/createSiteSearch/img_design_button.png';
import CloseIcon from '@material-ui/icons/Close';

const styleLeft = {
	width: "100%",
  height: "100%",
	backgroundImage: `url(${imgleft})`,
	backgroundRepeat: "no-repeat"
};

const styleRight = {
	width: "100%",
  height: "100%",
	backgroundImage: `url(${imgright})`,
	backgroundRepeat: "no-repeat"
};

//左のデザイン画像
const LEFT_IMG = 1
//右のデザイン画像
const RIGHT_IMG = 2

class Step3 extends React.Component {

	//左側のデザインのclassNameに指定する値を取得
	getLeftCheckClass(type){

			console.log("getCheckClass1() in")

			if(this.props.searchFormDesign == LEFT_IMG){
					return " selected-temp"
			}else{
					return ""
			}
	}

	//右側のデザインのclassNameに指定する値を取得
	getRightCheckClass(type){

			console.log("getCheckClass2() in")

			if(this.props.searchFormDesign == RIGHT_IMG){
					return " selected-temp"
			}else{
					return ""
			}
	}

	//親コンポーネントを呼び出す
	changeFormDesign(type){
		return this.props.updateSearchFormDesign(type);
		console.log(this.props)
	}

	//親コンポーネントを呼び出す
	handleCloseModal() {
		this.props.closeModal();
	}

	render() {

		//stepの初期化
		let modal = [];

		console.log(this.props.isDispModal)

		//モーダル表示フラグ
		if(this.props.isDispModal){
			modal.push(
				<div className="modal" style={{display: "block"}}>
					<div className="over-lay modal-close" onClick={() => { this.handleCloseModal(); }}></div>
					<div className="modal-inner" style={{width: "300px", animation: "0.3s ease 0s 1 normal forwards running modal"}} >
						<div className="modal-header">
							<span className="modal-title">エラー</span>
							<CloseIcon className="icon-close modal-close" style={{ fontSize: 19}} onClick={() => { this.handleCloseModal(); }}/>
						</div>
						<div className="modal-contents">{this.props.modalErrorMessage}</div>
						<button id="button-close" className="button modal-close" onClick={() => { this.handleCloseModal(); }}>OK</button>
					</div>
				</div>
			)
		}

	  return (
			<div id="contents_body">
				<div id="main-area">
					<div class={"temp-design"+ this.getLeftCheckClass(this.props.searchFormDesign)}>
						<img style={ styleLeft } onClick={() => { this.changeFormDesign(LEFT_IMG); }}/>
						<div class="checked"></div>
						<div class="design-text">
							<p class="design-title">検索フォーム</p>
						</div>
					</div>
					<div class={"temp-design"+ this.getRightCheckClass(this.props.searchFormDesign)}>
						<img style={ styleRight} onClick={() => { this.changeFormDesign(RIGHT_IMG); }}/>
						<div class="checked"></div>
						<div class="design-text">
							<p class="design-title">検索フォーム＋ボタン</p>
						</div>
					</div>
				</div>
				{modal}
			</div>
		);
  }
}

export default Step3;